
import ZMessage from "zobject/ZMessage.js";
import {doc} from '../docs.js';
import SubPatch from "zobject/SubPatch.js";

// essentially does exactly what the plane-renderer subpatch does
doc(
    'three.planeRenderer',
    {
        "material": ""
    },
    "Renders a material as a plane",
    () => 1,
    {
        connects: [
            {
                inlet: "operation",
                outlet: "Output 1",
                object: "three.canvas",
            }
        ],
    }
);
export const planeRenderer = (object) => {
    object.needsLoad = true;
    let subpatch = new SubPatch(object.subSequence, object.sequencerEngine, object, "planeRenderer");
    let plane = subpatch.createZObject(0,0,"three.planeGeometry");
    let camera = subpatch.createZObject(0,0,"three.orthographicCamera 0 150 0 150 -1 1");
    let scene = subpatch.createZObject(0,0,"three.scene");
    let mesh = subpatch.createZObject(0,0,"three.mesh");

    // need to hijack the outoput of render and send out this outlet
    let render = subpatch.createZObject(0,0,"three.render");

    // connect them up

    render.connectInlet("camera", camera, "Output 1");
    render.connectInlet("Input", scene, "Output 1");
    scene.connectInlet("Input", mesh, "Output 1");
    mesh.connectInlet("geometry", mesh, "Output 1");

    let piper = new ZMessage(subpatch, undefined, (msg) => {
        // console.log("PIPER GOT MSG", msg);
        object.sendMessage(
            object.outputByNumber(0),
            msg)
    });
    piper.connectInlet("Input", render, "Output 1");

    console.log(piper);

    return ([material]) => {
        if (material === "dispose") {
            return;
        }
        // console.log("plane-renderer message received =", material);
        if (material === "start") {
            plane.bang();
            camera.bang();
            return;
        }

        // what we need to do is take the outlet from render and use it as the outlet here

        // send the material to mesh
        if (mesh.args && material) {
            plane.bang();
            camera.bang();
            //console.log('sending materialt o mesh');
            mesh.lastMessageReceived = [plane.geometry];
            mesh.onArg(1, [material]);
            //console.log("mesh.args[0] = ", mesh.args[0]);
        }
    };
};
